import { getThumbBySize } from '../../../../../../util/photo';
import { HIERARCHY_ITEM_TYPE } from '../../../../../../constants/albums';
import { IMAGE_SIZE_CODE } from '../../../../../../constants/image-size-codes';

export const getSearchResultsFromHierarchyItems = hierarchyItems => {
  const { ALBUM, ALBUM_FOLDER } = HIERARCHY_ITEM_TYPE;
  const { MEDIUM2X } = IMAGE_SIZE_CODE;

  return hierarchyItems.map(genericResultItem => {
    const {
      album,
      album_folder: albumFolder,
      item_type: type,
    } = genericResultItem;
    const {
      has_password: hasPassword,
      start_date: startDate,
      end_date: endDate,
    } = type === ALBUM_FOLDER ? albumFolder : album;

    const hierarchyResult = {
      hasPassword,
      startDate,
      endDate,
      type,
      childAlbumCount:
        type === ALBUM_FOLDER ? genericResultItem.albums.total : undefined,
    };

    // Gallery specific data we want.
    let entitySpecificData = {};
    if (type === ALBUM_FOLDER) {
      entitySpecificData = {
        ...albumFolder,
        coverPhotoUrl: albumFolder.cover_photos?.records?.[0]
          ? getThumbBySize(
              albumFolder.cover_photos.records[0].thumbnail_urls,
              MEDIUM2X,
            ).url
          : undefined,
      };
    }
    // Album specific.
    if (type === ALBUM) {
      entitySpecificData = {
        ...album,
        coverPhotoUrl: album.cover_photo
          ? getThumbBySize(album.cover_photo.thumbnail_urls, MEDIUM2X).url
          : undefined,
      };
    }

    return {
      ...entitySpecificData,
      ...hierarchyResult,
    };
  });
};
